<div class="w-full max-w-md px-6 py-4 bg-card rounded-2xl">
  <h2 class="text-xl font-semibold text-primary mb-4">{{ data.title }}</h2>

  <p class="text-base text-muted mb-6">{{ data.message }}</p>

  <div class="flex justify-end space-x-2">
    <button
      mat-stroked-button
      mat-dialog-close
      class="min-w-[100px]"
      >
      {{ data.cancelText || 'Cancelar' }}
    </button>

    @if (data.confirmText) {
      <button
        mat-flat-button
        [color]="'primary'"
        [mat-dialog-close]="'confirm'"
        class="min-w-[100px]"
        >
        {{ data.confirmText }}
      </button>
    }
  </div>
</div>
